'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './calendar-list.routes';

export class CalendarListComponent {

  constructor(CalendarEventService, IntegrationService, $uibModal, $timeout, Auth, $state, Config, $http) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.$timeout  = $timeout;
    this.isAdmin = Auth.isAdminSync;
    this.$http = $http;
    this.calendarConfig = Config.getModuleConfig(Config.Modules.Calendar).getCalendarConfig();

    var generalConfig = Config.getModuleConfig(Config.Modules.General);
    var caledarConfig = Config.getModuleConfig(Config.Modules.Calendar);

    this.calendarEventUserContributionAllowed = caledarConfig.getTypesUserContribution();

    this._title = this.group ? this.group : this.type;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, this._title + " Calendar");

    this.groups = caledarConfig.getCalendarGroup();

    this.timezone = generalConfig.getClientTimezone();

    this.types = [];

    if (this.group) {
      this.types = this.groups[this.group];
    } else {
      this.types.push(this.type);
    }

    this.types.forEach(type => {
      this.eventSources.push({
        events: [],
        color: this.calendarConfig[type] && this.calendarConfig[type].color || '#ffcc66',
        textColor: this.calendarConfig[type] && this.calendarConfig[type].textColor || 'black'
      });
    });

    var that = this;

    var getData = function() {

      that.types.forEach(type => {

        let idx = that.types.indexOf(type);

        if (type.startsWith('master:')) {
          let category = type.split(':')[1];
          IntegrationService.getCalendarByType({type: category}, data => {

            if (that.eventSources.length && that.eventSources[idx].events.length) {
              that.eventSources[idx].events.splice(0, that.eventSources[idx].events.length);
            }

            data.forEach(evt => {

              var event = evt;

              event.orig = {
                start: event.start,
                end: event.end
              };

              if (event.isRecurring) {
                event.range = {start: event.start, end: event.recurrence.until};

                event.start = moment(event.start).format("HH:mm");

                if (event.end)
                  event.end = moment(event.end).format("HH:mm");

                event.dow = event.recurrence.dayOfWeek;
                event.id = event._id;
              }

              event.isExtern = true;
              that.eventSources[idx].events.push(event);
            });

          }, err => {
            console.log('could not retrieve events from server');
          });
        } else if (type === "@florida-holidays") {
          that.$http({
            method: 'GET',
            url: 'https://conduu-cdn.s3.amazonaws.com/resources/florida-holidays.json'
          }).then(response => {
            if (that.eventSources.length && that.eventSources[idx].events.length) {
              that.eventSources[idx].events.splice(0, that.eventSources[idx].events.length);
            }
            response.data.forEach(event => {
              event.isExtern = true;
              event.start = moment(event.start);
              that.eventSources[idx].events.push(event);
            });
          })
        } else {
          CalendarEventService.getByType({type: type}, data => {

            if (that.eventSources.length && that.eventSources[idx].events.length) {
              that.eventSources[idx].events.splice(0, that.eventSources[idx].events.length);
            }

            data.forEach(evt => {

              var event = evt;

              event.orig = {
                start: event.start,
                end: event.end
              };

              if (event.isRecurring) {
                event.range = {start: event.start, end: event.recurrence.until};

                event.start = moment(event.start).format("HH:mm");

                if (event.end)
                  event.end = moment(event.end).format("HH:mm");

                event.dow = event.recurrence.dayOfWeek;
                event.id = event._id;
              }

              that.eventSources[idx].events.push(event);
            });

          }, err => {
            console.log('could not retrieve events from server');
          });
        }
      });

    };

    this.getData = getData;
    getData();

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        header: {
          left: 'title',
          center: 'month,agendaWeek,listMonth',
          right: 'today prev,next'
        },
       viewRender: (view, el) => {
         /* This is a hack, because the stick property of the event doesn't work with recurring events,
         so that these will appear multiple times per day - that's a bug.
         This hack solved the stick issue without using stick itself and thus corrupting recurring events:
         https://github.com/angular-ui/ui-calendar/issues/276 */

         jQuery('#fullCalendar').fullCalendar('removeEvents');
         this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
         })
        },
        eventRender: (event, el) => {

          // Recurring Events
          if (event.isRecurring) {
            if (! (event.start.isSameOrBefore(event.range.end, 'day') && event.start.isSameOrAfter(event.range.start,'day')) ) {
              /*
              console.log(event.start.toString(), " || ", event.range.start);
              console.log("event.start.isAfter(event.range.start)", event.start.isSameOrAfter(event.range.start,'day'));
              console.log("recurring but out of range", event);
             */
              return false;
            }
          }

          // Timezone Difference Info
          var timeZoneDiffMin = this.getTimezoneDifference(this.timezone);

          var getTimezoneDiffString = function(mins) {
            var prefix = "+";
            if (mins < 0)
              prefix = "-";

            mins = Math.abs(mins);

            var h = mins / 60 | 0,
                m = mins % 60 | 0;

            if (String(h).length == 1)
              h = "0" + String(h);

            if (String(m).length == 1)
              m = "0" + String(m);

            return prefix + String(h) + ":" + String(m);
          };

          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);

          // render the timezone offset below the event title, if
          // user is in other timezone and the event is not all day
          if (!event.allDay && timeZoneDiffMin != 0) {
            el.find('.fc-title').after(
              jQuery('<div class="tzo text-muted"/>').text( timeZoneDiffStr )
            );
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'calendarEventDetail',
            resolve: {
              calendarEvent: function () {
                return calendarEvent;
              },
              config: function() {
                return {
                  group: that.group,
                  userHasPermission:
                    !calendarEvent.isExtern && (
                      that.Auth.isAdminSync()
                      || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                    )
                }
              }
            }
          });

          modalInstance.result.then(
            function (result) {

              if (result.action === 'removed') {
                that.$timeout(() => {
                  that.getData();
                },0);
              }

            },
            function () { /* cancel */ }
          );

        }
      }
    };
  }

  userContributionAllowed() {
    if (this.group)
      return false;

    return this.calendarEventUserContributionAllowed
      && this.calendarEventUserContributionAllowed.indexOf(this.type) !== -1;
  }

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

}

export default angular.module('conduuApp.calendarList', [uiRouter])
  .config(routes)
  .component('calendarList', {
    template: require('./calendar-list.html'),
    controller: CalendarListComponent,
    bindings: {
      type: '@',
      group: '@'
    },
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/calendar/list/calendar-list.component.js